import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const CARDIOLOGY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.diagnosisLabel,
  },
  {
    key: "therapy_and_clinical_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .therapyAndCourseLabel,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .medicalHistoryLabel,
  },
  {
    key: "social_history",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .socialHistoryLabel,
  },
  {
    key: "allergies",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.allergyLabel,
  },
  {
    key: "physical_status",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .physicalStatusLabel,
  },
  {
    key: "findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.findingsLabel,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.labResultsLabel,
  },
  {
    key: "ecg",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.ecgLabel,
  },
  {
    key: "additional_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .furtherDiagnosisLabel,
  },
  {
    key: "admission_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .admissionMedicationLabel,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .dischargeMedicationsLabel,
  },
  {
    key: "recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .recommendationsLabel,
  },
  {
    key: "appointments",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology
        .appointmentsLabel,
  },
  {
    key: "laboratory_parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formCardiology.parametersLabel,
  },
];

export function createCardiologyDischargeLetterPdf(
  props: PdfCreatorProps<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY>,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
  >(props, CARDIOLOGY_FIELD_CONFIG);
}
